export enum AuthModuleFeatureEnum {
    AiService = 'AiService',

    BerthPlanning = 'BerthPlanning',
    
    Map = 'Map',
    Map_AisStatus = 'Map_AisStatus',
    Map_Analysis = 'Map_Analysis',
    Map_CETACETD = 'Map_CETACETD',
    Map_GlobalVessel = 'Map_GlobalVessel',
    Map_Layers = 'Map_Layers',
    Map_Routes = 'Map_Routes',
    Map_TideMap = 'Map_TideMap',
    
    MasterDataLocation = 'MasterData_Location',
    MasterDataOrganization = 'MasterData_Organization',
    MasterDataUser = 'MasterData_User',
    MasterDataVessel = 'MasterData_Vessel',
    
    VesselSchedule = 'VesselSchedule',
    VesselVisit = 'VesselVisit',
}

export interface IRootModulePathMapping {
    path: string;
    name: AuthModuleFeatureEnum;
}

export class RootModulePathMappings {

    static BerthPlanning: IRootModulePathMapping = {
        path: 'berth-planning',
        name: AuthModuleFeatureEnum.BerthPlanning,
    };

    static Map: IRootModulePathMapping = {
        path: 'map',
        name: AuthModuleFeatureEnum.Map,
    };

    static MapAisStatus: IRootModulePathMapping = {
        path: 'map/ais-status',
        name: AuthModuleFeatureEnum.Map_AisStatus,
    };

    static MapTideMap: IRootModulePathMapping = {
        path: 'map/tide-map',
        name: AuthModuleFeatureEnum.Map_TideMap,
    };

    static MasterDataLocation: IRootModulePathMapping = {
        path: 'master-data/location',
        name: AuthModuleFeatureEnum.MasterDataLocation,
    };

    static MasterDataOrganization: IRootModulePathMapping = {
        path: 'master-data/organization',
        name: AuthModuleFeatureEnum.MasterDataOrganization,
    };

    static MasterDataUser: IRootModulePathMapping = {
        path: 'master-data/user',
        name: AuthModuleFeatureEnum.MasterDataUser,
    };

    static MasterDataVessel: IRootModulePathMapping = {
        path: 'master-data/vessel',
        name: AuthModuleFeatureEnum.MasterDataVessel,
    };

    static VesselSchedule: IRootModulePathMapping = {
        path: 'vessel-schedule',
        name: AuthModuleFeatureEnum.VesselSchedule,
    };

    static VesselVisit: IRootModulePathMapping = {
        path: 'vessel-visit',
        name: AuthModuleFeatureEnum.VesselVisit,
    };

    static routeModules: IRootModulePathMapping[] = [
        RootModulePathMappings.BerthPlanning,
        RootModulePathMappings.Map,
        RootModulePathMappings.MapAisStatus,
        RootModulePathMappings.MapTideMap,
        RootModulePathMappings.MasterDataLocation,
        RootModulePathMappings.MasterDataOrganization,
        RootModulePathMappings.MasterDataUser,
        RootModulePathMappings.MasterDataVessel,
        RootModulePathMappings.VesselSchedule,
        RootModulePathMappings.VesselVisit,
    ];

    static getModuleByPath(url: string): IRootModulePathMapping | undefined {
        const paths = url.split('?')[0].split('/').filter(x => x).map(x => x.toLowerCase());
        const path = paths.join('/');
        return this.routeModules.find(
            (m) => {
                const modulePath = m.path.toLowerCase();
                return modulePath.indexOf("/") >= 0 ? path.startsWith(modulePath) : path === modulePath;
            }
        );
    }

    static getModuleByName(name: AuthModuleFeatureEnum): IRootModulePathMapping | undefined {
        return this.routeModules.find((m) => m.name === name);
    }
}
